import {useEffect} from 'react';

const useOnFocusChange = (callback) => {
    useEffect(() => {
        const handleFocusChange = () => {
            if (document.hasFocus()) {
                callback();
            }
        };

        window.addEventListener('focus', handleFocusChange);

        return () => {
            window.removeEventListener('focus', handleFocusChange);
        };
    }, [callback]);
};

export default useOnFocusChange;
